import { ScheduleRequestEventData } from '@frontend/schedule-helpers';
import { CalendarView } from '../../components/calendar-view/calendar-view';
import { CalendarViewMainV3 } from '../../components/calendar-view/calendar-view-v3/calendar-view-main';
import { CalendarViewOffices } from '../../components/calendar-view/types';
import { ZoomProvider } from '../../components/calendar-view/zoom/zoom-context';
import { ZoomControls } from '../../components/calendar-view/zoom/zoom-controls';
import { EventCardComponent } from '../../components/schedule-calendar-components/event-card';
import { CalendarEventType } from '../Calendar/types';
import { CalendarAutoScroll } from './components/calendar-auto-scroll';
import { OnboardingFlowEmptyCalendarComponent } from './onboarding-flow/onboarding-flow-empty-calendar-component';

export type CalendarTimeLineViewV3Props = {
  calendarObject: CalendarViewOffices;
  isLoadingCalendarEvents: boolean;
  hasWSM: boolean;
  calendarDate: string;
  handleConfiguredCalendarEvent: (configuredCalendarEvent: CalendarEventType) => void;
  selectedScheduleRequestEventData: ScheduleRequestEventData | null;
  setSelectedScheduleRequestEventData: (request: ScheduleRequestEventData | null) => void;
};

export const CalendarTimeLineViewV3 = ({
  calendarObject,
  isLoadingCalendarEvents,
  hasWSM,
  calendarDate,
  handleConfiguredCalendarEvent,
  selectedScheduleRequestEventData,
  setSelectedScheduleRequestEventData,
}: CalendarTimeLineViewV3Props) => {
  return (
    <CalendarView
      data={calendarObject}
      onEventCreate={(startHour, endHour, providerName, providerId, isValid, locationId, calendarDateValue) => {
        handleConfiguredCalendarEvent({
          startHour,
          endHour,
          providerName,
          providerId,
          isValid,
          locationId,
          calendarDateValue,
        });
      }}
      EventCardComponent={EventCardComponent}
      shouldAllowEventCreation={hasWSM}
      EmptyCalendarComponent={isLoadingCalendarEvents ? undefined : OnboardingFlowEmptyCalendarComponent}
      calendarDate={calendarDate}
    >
      <ZoomProvider>
        <CalendarAutoScroll calendarObject={calendarObject} isLoadingCalendarEvents={isLoadingCalendarEvents} />
        <CalendarViewMainV3
          selectedScheduleRequestEventData={selectedScheduleRequestEventData}
          setSelectedScheduleRequestEventData={setSelectedScheduleRequestEventData}
        />
        <ZoomControls />
      </ZoomProvider>
    </CalendarView>
  );
};
